const NameBreak = {
  filters: {
    nameBreak (name, maxLength) { // Truncates long names (due to css wrapping issues)
      if (maxLength === undefined) {
        maxLength = 20
      }
      if (name.length <= maxLength) {
        return name
      } else {
        return name.substr(0, maxLength - 3) + '...'
      }
    }
  }
}

export default NameBreak



// WEBPACK FOOTER //
// ./src/mixins/NameBreak.js